<script>
import { toRef } from "vue";
import { useField } from "vee-validate";
import Slider from "@vueform/slider";

export default {
  components: {
    Slider,
  },
  inject: ["store"],
  emits: ["onEvaluateValueResetter"],
  props: {
    field: {},
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: String,
      default: "",
    },
    step: {
      type: Number,
      default: -1,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // use `toRef` to create reactive references to `name` prop which is passed to `useField`
    // this is important because vee-validte needs to know if the field name changes
    // https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
    const name = toRef(props, "name");

    // we don't provide any rules here because we are using form-level validation
    // https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(name, undefined, {
      initialValue: 0,
    });

    return {
      handleChange,
      handleBlur,
      errorMessage,
      inputValue,
      meta,
    };
  },
  computed:{
    dir(){
      return this.store.lang =='en'? 'ltr':'rtl';
    }
  },
  methods: {
    ResetResponseValues() {
      this.$emit("onEvaluateValueResetter", this.field);
      const opts = [...this.field.options];
      this.store.calcModel[this.field.id] = opts[this.inputValue-1].value;
    },
    changeStep(value){
      this.inputValue = value +1;
      this.ResetResponseValues()
    }
  },
  mounted(){
    const opts = [...this.field.options];
    if(opts.length > 0){
      this.store.calcModel[this.field.id] = opts[0].value;
    }
    // console.log(this.store.calcModel[this.field.id])
  }
};
</script>

<template>
  <ul class="rz-ticks">
    <template v-for="(option, step_index) in field.options" :key="option.value">
      <li :class='{"rz-active": (inputValue >= step_index+1), "rz-tick": true}'>
        <span class="rz-tick-value" @click="changeStep(step_index)">{{option.label || option.value}}</span>
      </li>
    </template>
  </ul>

  <Slider
    class="stepper"
    :step="1"
    :tooltips="false"
    v-model.number="inputValue"
    :lazy="false"
    :direction="dir"
    :min="1"
    :max="field.options.length || 2"
    @change="ResetResponseValues"
    ref="stepper"
  />
  
  <input 
  type="text"
  v-model="this.store.calcModel[this.field.id]" :id="field.id" 
  :name="field.title" 
  style="display: none;" />
</template>